import { oreqGetUserOfferRequests, oreqSaveFields } from "./api_client/api_offer_request";
import { coappGetUserCoapplicants } from "./api_client/api_coapplicant";
import { agentGetInfo } from './api_client/api_reagent';
import Modal from "./Modal";
import EventBus from "./Event";

class OffersTable {
  constructor(el) {
    this.el = el;
    this.$el = $(el);

    this.$head = this.$el.find('[data-offers-table="head"]');
    this.$body = this.$el.find('[data-offers-table="body"]');
    this.$template = this.$el.find('[data-offers-row-template]');
    this.$propertyName = this.$el.find('[data-offers-table="property-name"]');
    this.$releaseDate = this.$el.find('[data-offers-table="release-date"]');
    this.$status = this.$el.find('[data-offers-table="status"]');
    this.$actions = this.$el.find('[data-offers-table="actions"]');
    this.$actionsTrigger = this.$el.find('[data-offers-table="actions-trigger"]');
    this.$actionsBody = this.$el.find('[data-offers-table="actions-body"]');
    this.$actionsDetails = this.$el.find('[data-offers-table="actions-details"]');
    this.$actionsCancel = this.$el.find('[data-offers-table="actions-cancel"]');
    this.$tplClone = this.$template.clone();

    this.$template.remove();
    this.userOfferRequests = [];
    this.coappOfferRequests = [];
    this.clientsOfferRequests = [];
    this.allOfferRequests = [];
    this.coapplicantsGroup = [];

    this.isAgent = window.location.pathname === '/dashboard-agent-home';
    
    this.bindEvents();

    window.grapp.instances = window.grapp.instances ? [...window.grapp.instances, this] : [this];
  }

  // init table
  async initTable() {
    const user = window.grapp.user;
    if (!user) {
      console.error('No user found');
      return;
    }

    await this.getUserOfferRequests();
    if (this.isAgent) {
      await this.getAgentClientsOfferRequests();
    } else {
      await this.getCoappsOfferRequests();
    }
    this.render();
  }

  // get user offer requests
  async getUserOfferRequests() {
    const user = window.grapp.user;

    try {
      const requests = await oreqGetUserOfferRequests(user.auth.email);
      if (requests.success) {
        this.userOfferRequests = requests.offerRequests || [];
      }
      
      if (this.userOfferRequests.length) {
        this.userOfferRequests.forEach(offerRequest => {
          offerRequest.is_own = true;
        });
        this.allOfferRequests = [...this.userOfferRequests, ...this.allOfferRequests];
      }
    } catch(err) {
      console.error('Error getting user offer requests: ', err);
    }
  }

  // get coapplicants offer requests
  async getCoappsOfferRequests() {
    const user = window.grapp.user;

    const coapplicantsReq = await coappGetUserCoapplicants(user.auth.email);
    if (coapplicantsReq.success && coapplicantsReq.fields?.coapplicants.length) {
      this.coapplicantsGroup = [
        coapplicantsReq.fields.coapplicants_owner_info,
        ...coapplicantsReq.fields.coapplicants,
      ];
      console.log('coapplicantsGroup: ', this.coapplicantsGroup);
      EventBus.emit('offers-table:coapplicants-loaded', this.coapplicantsGroup);

      const coappOfferRequests = await Promise.all(coapplicantsReq.fields.coapplicants.map(async (coapp) => {
        const coappOfferRequestsReq = await oreqGetUserOfferRequests(coapp.email);
        if (coappOfferRequestsReq.success && coappOfferRequestsReq.offerRequests?.length) {
          return coappOfferRequestsReq.offerRequests;
        } else {
          return [];
        }
      }));

      if (coappOfferRequests.length) {
        this.coappOfferRequests = [...coappOfferRequests.flat()];
        this.allOfferRequests = [...this.allOfferRequests, ...this.coappOfferRequests];
      }
    } else if (coapplicantsReq.success && !coapplicantsReq.fields?.coapplicants?.length) {
      this.coapplicantsGroup = [ coapplicantsReq.fields.coapplicants_owner_info ];
      EventBus.emit('offers-table:coapplicants-loaded', this.coapplicantsGroup);
    } else if (!coapplicantsReq.success) {
      console.error('Error getting coapplicants: ', coapplicantsReq);
      EventBus.emit('toast', { 
        message: 'Error loading coapplicants. Please refresh this window to try again.', 
        type: 'error' 
      });
    }
  }

  async getAgentClientsOfferRequests() {
    const user = window.grapp.user;

    const agentInfoReq = await agentGetInfo(user.auth.email);
    if (agentInfoReq.success && agentInfoReq.reagent) {
      const clientsList = agentInfoReq.reagent.reagent_clients_list?.split(',') || [];
      const clientsOfferRequests = await Promise.all(clientsList.map(async client => {
        const clientOfferRequestsReq = await oreqGetUserOfferRequests(client);
        if (clientOfferRequestsReq.success) {
          return clientOfferRequestsReq.offerRequests;
        } else {
          return [];
        }
      }));
      // console.log('clientsOfferRequests: ', clientsOfferRequests);
      console.log('this.userOfferRequests: ', this.userOfferRequests);
      if (clientsOfferRequests.length) {
        this.clientsOfferRequests = [...clientsOfferRequests.flat()];
        this.allOfferRequests = [...this.allOfferRequests, ...this.clientsOfferRequests];
      }
    }
  }

  bindEvents() {
    EventBus.on('user:loaded', this.initTable.bind(this));
    EventBus.on('offer-request:submitted', this.onAddOfferRequest.bind(this));
    EventBus.on('offer-request:fields-saved', this.onAddOfferRequest.bind(this));

    this.$el.find('[data-offers-table="body"]')
      .on('click', '[data-offers-table="actions-trigger"]', this.onActionsTrigger.bind(this))
      .on('click', '[data-offers-table="actions-details"]', this.onActionsDetails.bind(this))
      .on('click', '[data-offers-table="actions-cancel"]', this.onActionsCancel.bind(this))
      .on('click', '[data-offers-table="actions-continue"]', this.onActionsContinue.bind(this))
      .on('click', '[data-offers-table="actions-revoke"]', this.onActionsRevoke.bind(this));

    $(document.body).find('[data-clear-offer-request').on('click', () => {
      EventBus.emit('offer-request:clear');
      this.onActionsContinue.bind(this);
    });
    $(document.body).find('[data-form-action="revoke"]').on('click', this.onConfirmRevoke.bind(this));
  }

  onActionsTrigger(e) {
    console.log('actions trigger');
    const $trigger = $(e.currentTarget);
    const $row = $trigger.closest('[data-offers-table="offer"]');
    const $actionsBody = $row.find('[data-offers-table="actions-body"]');

    $actionsBody.toggleClass('open');
  }

  onActionsDetails(e) {
    const $target = $(e.currentTarget);
    const $row = $target.closest('[data-offers-table="offer"]');
    const offerId = $row.data('offer-id');
    const offerRequestDetails = this.allOfferRequests.find(({oreq_id}) => +oreq_id === +offerId);

    // update property details in modal
    const $propDetailsWrap = Modal.getContentElement('property-details', '[data-prop-details="wrap"]');
    // Map values to user friendly text
    const valuesMap = {
      //format date as 'Month Day, Year'
      'oreq_signature_date_1': (value) => value ? new Date(value).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }) : 'N/A',
      'oreq_status': (value) => value ? value.charAt(0).toUpperCase() + value.slice(1) : '',
      'oreq_new_paint': (value) => value ? value.charAt(0).toUpperCase() + value.slice(1) : 'No',
      'oreq_paint_color': (value) => value 
        ? value.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')
        : 'N/A',
      'oreq_carpet': (value) => value ? value.charAt(0).toUpperCase() + value.slice(1) : 'No',
      // 'oreq_carpet_option': (value) => value 
      //   ? value.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')
      //   : 'N/A',
      // appliance replacement
    }

    if (offerRequestDetails && $propDetailsWrap.length) {
      const appliances = [];
      Object.keys(offerRequestDetails).forEach(key => {
        const $propDetail = $propDetailsWrap.find(`[data-prop-detail="${key}"]`);
        const isApplianceField = key.indexOf('oreq_replace_') === 0 && key !== 'oreq_replace_others' && key !== 'oreq_replace_others_description';
        if (!$propDetail.length && !isApplianceField) return;

        if (isApplianceField) {
          if (offerRequestDetails[key] === 'yes') {
            const applianceLabel = key.split('oreq_replace_')[1].split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
            appliances.push(applianceLabel);
          }
          return;
        }

        if (key === 'oreq_paint_walls_entire' || key === 'oreq_carpeting_areas_entire') {
          const value = offerRequestDetails[key];
          
          if (value === 'yes') {
            $propDetail.text('Entire Interior');
          } else {
            $propDetail.remove();
          }
        } else if (key === 'oreq_paint_walls_detail' || key === 'oreq_carpeting_areas_detail') {
          const value = offerRequestDetails[key];
          $propDetail.text(value || 'N/A');
          if (value) {
          } else {
            $propDetail.remove();
          }
        } else {
          // $propDetail.text(offerRequestDetails[key] || 'N/A');
          const text = valuesMap[key] ? valuesMap[key](offerRequestDetails[key]) : offerRequestDetails[key] || 'N/A';
          $propDetail.text(text);
        }
      });

      const $appliances = $propDetailsWrap.find(`[data-prop-detail="oreq_appliances"]`);
      $appliances.text(appliances.join(', '));
    } else {
      const modalTpl = `
        <div>Whoops! Something went wrong loading this property's request details. Please refresh the page and try again.</div>
      `;
      const $modalContent = $(modalTpl);
      Modal.updateInnerContent('property-details', '[data-modal-content="property-details"]', $modalContent);
    }
    $propDetailsWrap.closest('modal_main').scrollTop(0);
    // open modal
    Modal.open('property-details');

    const $actionsBody = $row.find('[data-offers-table="actions-body"]');
    $actionsBody.removeClass('open');
  }

  onActionsCancel(e) {
    const $target = $(e.currentTarget);
    const $row = $target.closest('[data-offers-table="offer"]');
    const $actionsBody = $row.find('[data-offers-table="actions-body"]');

    $actionsBody.removeClass('open');
  }

  // response: { success: true, newOreqCreated: true, fields: {}}
  onAddOfferRequest(response) {
    const { fields: offerRequest } = response;

    // if offerRequest with current id already exists, update with new values and return
    let existingOfferRequest = this.allOfferRequests.find((oreq) => +oreq.oreq_id === +offerRequest.oreq_id);

    if (existingOfferRequest) {
      this.allOfferRequests = this.allOfferRequests.map((oreq) => {
        if (+oreq.oreq_id === +offerRequest.oreq_id) {
          return offerRequest;
        }
        return oreq;
      });
      return;
    }

    this.allOfferRequests && this.allOfferRequests.push(offerRequest);
    this.renderRow(offerRequest);
    
    if (offerRequest.oreq_status !== 'draft') {
      Modal.close('offer-request');
    }
  }

  onActionsContinue(e) {
    e.preventDefault();
    const $target = $(e.currentTarget);
    const $row = $target.closest('[data-offers-table="offer"]');
    const offerId = $row.data('offer-id');
    const offerRequest = this.allOfferRequests.find(({oreq_id}) => +oreq_id === +offerId);
    
    EventBus.emit('offer-request:continue', offerRequest);
    $row.find('[data-offers-table="actions-body"]').removeClass('open');
    Modal.open('offer-request');
  }

  onActionsRevoke(e) {
    e.preventDefault();
    const $target = $(e.currentTarget);
    const $row = $target.closest('[data-offers-table="offer"]');
    const offerId = $row.data('offer-id');
    const $confirmRevoke = $(document.body).find('[data-form-action="revoke"]');

    // get 'confirm' button from modal content
    $confirmRevoke.data('offer-id', offerId);
    $row.find('[data-offers-table="actions-body"]').removeClass('open');
    // Open 'Revoke' modal
    Modal.open('revoke-offer-request');
  }

  async onConfirmRevoke(e) {
    e.preventDefault();
    const $target = $(e.currentTarget);
    const offerId = $target.data('offer-id');
    const offerRequest = this.allOfferRequests.find(({oreq_id}) => +oreq_id === +offerId);
   
    // update offer request status to 'revoked'
    offerRequest.oreq_status = 'revoked';
    // update offer request in db
    try {
      const saveReq = await oreqSaveFields(offerRequest);
      console.log('saveReq: ', saveReq);
      if (saveReq.success) {
        // render table without revoked offer
        const $revokedOfferRow = this.$el.find(`[data-offers-table="offer"][data-offer-id="${offerId}"]`);
        $revokedOfferRow.remove();
        // close modal
        Modal.close('revoke-offer-request');
      }
    } catch(err) {
      console.error('Error saving offer revoke request: ', err);
    }
  }

  render() {
    if (!this.allOfferRequests || !this.allOfferRequests.length) {
      const $row = this.getRowTemplate({ oreq_property_address: 'No offers found', oreq_id: 0 });
      this.$body.append($row);
      return;
    } else {
      // remove 'No offers found' row if it exists
      this.$body.find('[data-offers-table="offer"]').each((i, el) => {
        const $el = $(el);
        if ($el.data('offer-id') == 0) {
          $el.remove();
        }
      });
    }

    this.allOfferRequests.forEach(offerRequest => {
      if (offerRequest.oreq_status === 'revoked') return;

      const $row = this.getRowTemplate(offerRequest);
      this.$body.append($row);
    });
  }

  renderRow(offerRequest) {
    const $row = this.getRowTemplate(offerRequest);

    this.$body.append($row);

    if (offerRequest.oreq_property_address !== 'No offers found') {
      this.$body.find('[data-offers-table="offer"]').each((i, el) => {
        const $el = $(el);
        if ($el.data('offer-id') == 0) {
          $el.remove();
        }
      });
    }
  }

  getRowTemplate(offerRequest) {
    const $row = this.$tplClone.clone();
    $row.find('[data-offers-table="property-name"]').text(offerRequest.oreq_property_address || '--');
    $row.find('[data-offers-table="release-date"]').text(offerRequest.oreq_signature_date_1 || '--');

    const $detailsAction = $row.find('[data-offers-table="actions-details"]');
    const $continueAction = $row.find('[data-offers-table="actions-continue"]');
    
    if (offerRequest.oreq_status === 'draft') {
      $detailsAction.remove();
      $continueAction.removeClass('with_border');
    } else {
      $detailsAction.removeClass('with_border');
      $continueAction.remove();
    }

    // check if any coapplicants signatures are pending
    // let anySignaturesPending = false;
    // const signaturesCount = Object.keys(offerRequest).filter(key => key.indexOf('oreq_signature_name_') === 0).length;
    // if (signaturesCount < this.coapplicantsGroup.length) {
    //   anySignaturesPending = true;
    // }
    // if (anySignaturesPending) {
    //   $continueAction.addClass('with_border');
    //   offerRequest.oreq_status = offerRequest.oreq_id == 0 ? '--' : 'pending';
    // }
    
    const statusClassMap = { 'approved': 'bg_primary', 'pending': 'bg_primary_light', 'signature_pending': 'bg_primary_light', 'rejected': 'bg_borders', };
    const statusTextMap = { 'approved': 'Approved', 'pending': 'Pending', 'signature_pending': 'Signatures Pending', 'rejected': 'Rejected', 'draft': 'Draft' };
    const $rowStatusIcon = $row.find('[data-offers-table="status"] div').first();
    const $rowStatusText = $row.find('[data-offers-table="status"] div').last();

    if (statusClassMap[offerRequest.oreq_status]) {
      $rowStatusIcon.addClass(statusClassMap[offerRequest.oreq_status]);
    }
    $rowStatusText.text(statusTextMap[offerRequest.oreq_status] || '--');
    $row.attr('data-offer-id', offerRequest.oreq_id);
    if (offerRequest.oreq_property_address === 'No offers found') {
      $row.find('[data-offers-table="actions"]').html('--');
    }

    return $row;
  }

  static init() {
    $('[data-js-component="offers-table"]').each((i, el) => new OffersTable(el));
  }
}

OffersTable.init();
